(function () {
  /* ── Gallery thumb switcher ── */
  window.ptSetThumb = function (el, src) {
    document.querySelectorAll('.pt-gallery-thumb, .pt-gallery-thumb-video').forEach(function (t) {
      t.classList.remove('active');
    });
    el.classList.add('active');
    document.querySelectorAll('.pt-gallery-main-img').forEach(function (img) {
      img.style.display = (img.getAttribute('src') === src) ? 'block' : 'none';
    });
  };

  /* ── FAQ accordion ── */
  window.ptToggleFaq = function (btn) {
    var item = btn.closest('.pt-faq-item');
    var isOpen = item.classList.contains('open');
    document.querySelectorAll('.pt-faq-item').forEach(function (i) { i.classList.remove('open'); });
    if (!isOpen) item.classList.add('open');
  };

  /* ── Scroll-triggered fade-ups ── */
  var els = document.querySelectorAll('.pt-fade-up');
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        e.target.classList.add('visible');
        observer.unobserve(e.target);
      }
    });
  }, { threshold: 0.12 });
  els.forEach(function (el) { observer.observe(el); });

  /* ── Sticky nav shadow on scroll ── */
  var nav = document.getElementById('pt-main-nav');
  if (nav) {
    window.addEventListener('scroll', function () {
      nav.style.boxShadow = window.scrollY > 80 ? '0 1px 12px rgba(0,0,0,0.06)' : 'none';
    }, { passive: true });
  }

  /* ── Scroll to final CTA ── */
  window.ptScrollToCta = function () {
    var el = document.getElementById('pt-final-cta');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };
})();
